import React from "react";

import { Modal } from "react-bootstrap";
import { WindowHeader, WindowFooter } from "layouts/Page/windows";

import ProfileBox from "./Box";

import { CurrentLoginDTO, RelationData, ProfileData } from "../ProfileDropdown";
export type { CurrentLoginDTO, RelationData, ProfileData };

const PerfilWindows: React.FC<{
    onHide: () => void;
    title: string;
    relationData: RelationData;
}> = ({ 
    onHide, 
    title, relationData 
}) => {
    return (
        <Modal show={true} onHide={onHide} size="lg" centered>
            <WindowHeader title={title} />
            <Modal.Body>
                <ProfileBox relationData={relationData} title={title} />
                <WindowFooter onCancel={onHide} cancelLabel="Fechar" hideConfirm />
            </Modal.Body>
        </Modal>
    )
}

export default PerfilWindows;
